import React, {useCallback} from "react";
import css from "./index.module.less";
import {getString} from "../../index";
import {App} from "../../App";
import ClipBoard from "react-copy-to-clipboard";
import {message} from "antd";

export const DownloadTutor = () => {
    const renderIndex = useCallback((index: number) => {
        return (
            <div style={{
                display: "flex",
                height: 22,
                width: 22,
                borderRadius: 22,
                fontWeight: "bold",
                backgroundColor: "#E5E5E5",
                alignItems: "center",
                justifyContent: "center",
                marginRight: 10
            }}>
                <span style={{color: "#333333", fontSize: 16}}>
                    {index}
                </span>
            </div>
        )
    }, []);

    const renderBottom = useCallback(() => {
        return (
            <div style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                marginBottom: 60,
                alignItems: "center"
            }}>
                <div style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
                    <img src={require("../../images/pionex.png")} alt={""}
                         style={{height: 50, width: 50, marginRight: 15}}/>
                    <div style={{display: "flex", flexDirection: "column", justifyContent: "space-between"}}>
                        <span className={css.lightText}>
                            {getString("download_tutor_pionex_desc1")}
                        </span>
                        <span className={css.lightText} style={{marginTop: 10}}>
                            {getString("download_tutor_pionex_desc2")}
                        </span>
                    </div>
                </div>

                <span style={{fontSize: 12, color: "#999999", marginTop: 15}}>
                    {getString("download_tutor_bottom_slogan")}
                </span>
            </div>
        )
    }, []);

    return (
        <App hideHeader={true}>
            <div className={css.downloadTutor}>
                <div style={{display: "flex", flexDirection: "column", alignItems: "center", marginTop: 30}}>
                    <img src={require("../../images/download_icon_wechat.png")} alt={""}
                         style={{height: 246, width: 245}}/>

                    <span style={{fontSize: 16, color: "black", marginTop: 25, width: "70%", textAlign: "center"}}>
                         {"点击复制按钮，在其他浏览器中粘贴后打开"}
                     </span>

                    <ClipBoard text={"https://download.pionex.cc/?lang=zh-CN"} onCopy={() => {
                        message.success("复制成功!");
                    }}>
                        <div style={{
                            backgroundColor: "#FF8E4D",
                            borderRadius: 5,
                            paddingLeft: 80,
                            paddingRight: 80,
                            marginTop: 25,
                            paddingTop: 5,
                            paddingBottom: 5
                        }}>
                    <span style={{fontSize: 14, fontWeight: "bold", color: "white"}}>
                        {"复制"}
                    </span>
                        </div>
                    </ClipBoard>
                </div>

                <div style={{
                    display: "flex",
                    flexDirection: "row",
                    flex: 1,
                    justifyContent: "center",
                    alignItems: "flex-end"
                }}>
                    {renderBottom()}
                </div>
            </div>
        </App>
    )
};
